import {LoadBalanceConfiguration} from '../../../../fields/loadBalance/types'
import {BuildConfigurationInput} from '../../../../types'
import {ChangeableFieldsOptionsDto} from '../../options/types'

export const buildLoadBalanceConfiguration = (
  input: BuildConfigurationInput,
  changeableFields: ChangeableFieldsOptionsDto
): LoadBalanceConfiguration => {
  const constraints = input.options.constraints.loadBalance

  // Not enabled in constraints, or not changeable per changeableFields → disable
  if (!constraints?.isEnabled || !changeableFields.maxLoadSize?.isEnabled) {
    return {loadBalance: {isEnabled: false}}
  }

  return {
    loadBalance: {
      isEnabled: true,
      eligibleQuantityRange: constraints.eligibleQuantityRange,
      maxTruckSize: constraints.maxTruckSize
    }
  }
}
